import { defineComponent } from "vue";

export const Row = defineComponent({
  name: "LISADataTableRowDeclaration",
  inheritAttrs: false,
  setup: () => () => null,
});
